import React from 'react'

import { PopupsContext } from '../context'
import { createPopupsStore } from '../store'

import type { PromotionPopupKey, PromotionPopups } from '../store'


import { useRef } from 'react';
export interface SitePromotionPopupsProviderProps<T extends PromotionPopups> {
  config: T
  children: React.ReactNode
}

export function SitePromotionPopupsProvider<T extends PromotionPopups>({
  config,
  children,
}: SitePromotionPopupsProviderProps<T>) {
  const newConfig = Object.fromEntries(
    Object.entries(config).filter(([_, promotion]) => !promotion?.disabled),
  )
  const store = useRef(createPopupsStore(newConfig)).current
  store.subscribe((state, prevState) => {
    if (state.initKeys.length < Object.keys(state.promotions).length) {
      return
    }
    const openPopups = Object.entries(state.promotions).filter(
      ([_, banner]) => banner.open,
    )

    if (openPopups.length > 0 && !state.closed) {
      // 排序
      const highestPriorityPopup = openPopups.reduce((prev, current) => {
        return current[1].priority > prev[1].priority ? current : prev
      })
      store.setState((state) => {
        state.openKey = highestPriorityPopup[0] as PromotionPopupKey<T>
        return state
      })
    }
  })

  return (
    <PopupsContext.Provider value={store as any}>
      {children}
    </PopupsContext.Provider>
  )
}
